import deadliftPlate from "@/assets/images/landing/deadlift-plate.webp";
import mealPrep from "@/assets/images/landing/meal-prep.webp";
import squatMono from "@/assets/images/landing/squat-mono.webp";

/**
 * The landing's photography, all from Unsplash (see assets/images/landing/CREDITS.md). They show
 * training, never a trainer on the platform: a real trainer is only ever shown by their own name.
 */
export const photos = {
  deadliftPlate,
  mealPrep,
  squatMono,
};
